import type React from 'react';
import {IconButton, Paper, Stack, Tooltip, Typography} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {HelpComponent} from '~/components/help-component/HelpComponent';

type Props = {
    /** Explains the chart (info icon after the title). */
    help?: string;
    title: string;
    subtitle?: string;
    /** Download the chart's figures as CSV; no button when absent. */
    onDownload?: () => void;
    children: React.ReactNode;
};

/** A chart in a card with its title inside, and a download button (Mithra 3.0 chart cards). */
export const ChartCard: React.FC<Props> = ({title, subtitle, help, onDownload, children}) => (
    <Paper variant="outlined" sx={{p: 2, borderRadius: 2, minWidth: 0}}>
        <Stack direction="row" alignItems="center" gap={1} sx={{mb: 1.5, minHeight: 28}}>
            <Typography variant="subtitle2" component="h3" sx={{fontWeight: 600}}>{title}</Typography>
            {help && <HelpComponent helpContent={<Typography variant="body2" sx={{maxWidth: 360}}>{help}</Typography>}/>}
            {subtitle && <Typography variant="caption" color="text.secondary" sx={{flex: 1}} noWrap>{subtitle}</Typography>}
            {onDownload && (
                <Tooltip title="Download as CSV">
                    <IconButton size="small" onClick={onDownload} aria-label={`Download ${title} as CSV`} sx={{ml: 'auto'}}>
                        <FileDownloadOutlinedIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
        {children}
    </Paper>
);
